import { gql, TypedDocumentNode } from "@apollo/client";

import { BlobStorageIntegration, QueryBlobStorageIntegrationArgs } from "types/generated";

export type BlobStorageIntegrationData = Pick<
  BlobStorageIntegration,
  | "id"
  | "name"
  | "description"
  | "isDefault"
  | "labels"
  | "space"
  | "subtype"
  | "authMethod"
  | "baseURI"
  | "region"
  | "endpoint"
  | "roleArn"
  | "externalId"
  | "accessKeyId"
  | "hasCredentials"
>;

type GetVCSBlobStorageIntegrationQuery = {
  blobStorageIntegration: BlobStorageIntegrationData;
};

export const GET_BLOB_STORAGE_INTEGRATION: TypedDocumentNode<
  GetVCSBlobStorageIntegrationQuery,
  QueryBlobStorageIntegrationArgs
> = gql`
  query GetBlobStorageIntegration($id: ID!) {
    blobStorageIntegration(id: $id) {
      id
      name
      description
      isDefault
      labels
      space {
        id
        name
        accessLevel
      }
      subtype
      authMethod
      baseURI
      region
      endpoint
      roleArn
      externalId
      accessKeyId
      hasCredentials
    }
  }
`;
